
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import CenterOnParent from '../../util/CenterOnParent';

@Component({
  components: {
    CenterOnParent,
  },
})
export default class Code extends Vue {
  code: number | null = null;
  enableFirstLetterOfLastName = false;
  firstLetterOfLastName = '';

  moveToFirstLetterOfLastNameBox(): void {
    this.enableFirstLetterOfLastName = true;
    this.$nextTick(() => {
      (this.$refs.firstLetterOfLastNameBox as HTMLInputElement).focus();
    });
  }

  // digit1: number | null = null;
  // digit2: number | null = null;
  // digit3: number | null = null;
  // digit4: number | null = null;
  // digit5: number | null = null;
  // digit6: number | null = null;
  //
  // get code(): string {
  //   return ''
  //       + (this.digit1 ?? ' ')
  //       + (this.digit2 ?? ' ')
  //       + (this.digit3 ?? ' ')
  //       + (this.digit4 ?? ' ')
  //       + (this.digit5 ?? ' ')
  //       + (this.digit6 ?? ' ');
  // }
  //
  // set code(value: string) {
  //   const i = parseInt(value, 10);
  //   this.digit1 = (i / 100000) % 10;
  //   this.digit2 = (i / 10000) % 10;
  //   this.digit3 = (i / 1000) % 10;
  //   this.digit4 = (i / 100) % 10;
  //   this.digit5 = (i / 10) % 10;
  //   this.digit6 = i % 10;
  // }
  //
  // onInput(event: KeyboardEvent, index: number): void {
  //   console.log('input', event, index);
  //   if (event.key >= '0' && event.key <= '9') {
  //     //move to next textbox
  //     const next = ((event.target as HTMLInputElement).nextSibling as (HTMLElement | null));
  //     if (next) {
  //       next.focus();
  //     } else {
  //       //last text box
  //       this.$nextTick(() => this.$emit('input', this.code));
  //     }
  //   }
  // }
  //
  // onPaste(event: ClipboardEvent, index: number): void {
  //   //paste
  //   const pastedString = (event.clipboardData?.getData('Text') ?? '').trim();
  //   if (!pastedString.match(/^[0-9]*$/)) {
  //     return;
  //   }
  //
  //   const newCode = (this.code.substring(0, index - 1) + pastedString).substring(0, 6);
  //   this.code = newCode;
  //   if (newCode.length === 6) {
  //     this.$nextTick(() => this.$emit('input', this.code));
  //   }
  // }
}
